@if (tooltipSheetService.content(); as sheetContent) {
  <div
    class="mobile-explain-sheet-host"
    [class.is-dragging]="isDragging()"
    [class.has-learn-more-footer]="!!tooltipSheetService.learnMoreLink()"
    [style.--sheet-drag-y.px]="dragOffsetPx()"
    [style.--sheet-drag-progress]="dragProgress()"
    (pointerdown)="onDragStart($event)"
    (pointermove)="onDragMove($event)"
    (pointerup)="onDragEnd($event)"
    (pointercancel)="onDragEnd($event)"
    (animate.leave)="onSheetLeave($event)"
  >
    <liberro-mobile-bottom-overlay-sheet
      [maxHeight]="maxHeight()"
      customTopMargin="12px"
    >
      <div class="mobile-explain-sheet">
        @if (tooltipSheetService.isTemplateRef(sheetContent)) {
          <ng-container *ngTemplateOutlet="sheetContent"></ng-container>
        } @else {
          <div class="mobile-explain-sheet-content">{{ sheetContent }}</div>
        }
      </div>
      @if (tooltipSheetService.learnMoreLink(); as learnMoreLink) {
        <liberro-button
          sheetFooter
          [label]="'global.button.learnMore' | translate"
          type="default"
          widthType="width-100"
          (btnClick)="onLearnMoreClick(learnMoreLink)"
        ></liberro-button>
      }
    </liberro-mobile-bottom-overlay-sheet>
  </div>
}
